<template>
  <footer
    class="p-3 mt-4 bg-dark text-white"
    placeholder="Firma arayın..."
    data-v-61d1a293=""
  >
    <div class="container text-center footer-info">
      2022 © Forienetwork All Rights Reserved.

      <div class="text-center mt-3 d-flex" style="align-items: flex-end;">
        <div
          v-if="
            this.$store.state.domainCustomVariablesX.filter(
              (q) => q.code == 'Facebook'
            ).length > 0
          "
          v-html="
            this.$store.state.domainCustomVariablesX.filter(
              (q) => q.code == 'Facebook'
            )[0].value
          "
        ></div>

        <div
          v-if="
            this.$store.state.domainCustomVariablesX.filter(
              (q) => q.code == 'Twitter'
            ).length > 0
          "
          v-html="
            this.$store.state.domainCustomVariablesX.filter(
              (q) => q.code == 'Twitter'
            )[0].value
          "
        ></div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer-info{
      display: flex !important;
    align-items: center;
    justify-content: center;
    flex-flow: column;
}
</style>